export class ContactProjectNoteApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get All Notes for contact project
     * @returns ContactProjectNote
     * @throws ApiError
     */
    getContactProjectNotes({ contactProjectId, pageSize, page, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/contact-project-note',
            query: {
                'pageSize': pageSize,
                'page': page,
                'contactProjectId': contactProjectId,
            },
        });
    }
    /**
     * Create new note.
     * @returns ContactProjectNote
     * @throws ApiError
     */
    create({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contact-project-note',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
